module.exports = require("diagnostics_channel");